import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { faPlus } from "@fortawesome/free-solid-svg-icons/faPlus";
import ModalControls from "../../common/ModalControls";
import { useNavigate, useLocation } from "react-router-dom";
import { defaultFormState } from "../../../../defaults/Forms";
import { taxOfficeDefault } from "../../../../defaults/Items";
import {
  onSaveAndClose,
  compareData,
  restoreFormData,
  onItemsListDeleteButtonClick,
  onCloseDetails, setForegroundColor
} from "../../../../helpers/ComponentHelper";

import AppComponentCardHeader from "../../common/AppComponentCardHeader";
import LoadingDataDiv from "../../common/LoadingDataDiv";
import DeleteWarningModal from "../../common/DeleteWarningModal";
import SettingsEntityModal from "../../common/SettingsEntityModal";
import ItemDetailsModalHeader from "../../common/ItemDetailsModalHeader";
import TextInput from "../../../elements/TextInput";
import TextArea from "../../../elements/TextArea";
import useCrud from "../../../../hooks/useCrud";
import { Table } from "../../../table/Table";
import Select from "../../../elements/Select";

import { MDBDataTableV5 } from "mdbreact";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";

const TaxOffice = () => {

  const dataUrl ="/tax-offices";
  const voivodeshipsUrl="/voivodeships";
  const relatedItemsUrl = null; // if no need to check it, initialize with null and remove RelatedItemsList from details modal
  const defaultItem = taxOfficeDefault;
  const itemName = "urząd skarbowy";
  const itemNames = "urzędy skarbowe";
  const navigate = useNavigate();
  const location = useLocation();
  const {createItem, updateItem, deleteItem, getItems, getRelatedChildrenByParentId} = useCrud(dataUrl);

  const [loading, setLoading] = useState(true);
  const [allowDelete, setAllowDelete] = useState(null);
  const [currentFormState, setCurrentFormState] = useState(defaultFormState);
  const [itemsList, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState(defaultItem);
  const [backupItem, setBackupItem] = useState(defaultItem);
  const [itemChanged, setItemChanged] = useState(false);
  const [updateConflict, setUpdateConflict] = useState(false);
  const [voivodeshipsList, setVoivodeships] = useState([]);


  // elements related to the item
  const columns = [
    {label: "Id", accessor: "id", sortable: true, searchable: false},
    {label: "Nazwa", accessor: "name", sortable: true, searchable: true},
    {label: "Adres (ulica i numer)", accessor: "address", sortable: true, searchable: true},
    {label: "Kod pocztowy", accessor: "postalCode", sortable: true, searchable: true},
    {label: "Miasto", accessor: "city", sortable: true, searchable: true},
    {label: "Kod", accessor: "code", sortable: true, searchable: true},
    {label: "Edycja", accessor: "editBtn", sortable: false, searchable: false},
    {label: "Usuń", accessor: "deleteBtn", sortable: false, searchable: false},
  ];


  const state = {
    itemsList, setItems,
    currentItem, setCurrentItem,
    currentFormState, setCurrentFormState,
    defaultItem, backupItem, setBackupItem, itemChanged, setItemChanged,
    setAllowDelete,
    setRelatedItems: null
  }


  const onDelete = async () => {
    const response = await deleteItem(`${dataUrl}/${currentItem.id}`, currentItem.id, state);
    if (response === 401 || response === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    }
  }


  const onSaveItemClick = async (e) => {
    e.preventDefault();
    if(!currentItem.name || !currentItem.address || !currentItem.postalCode || !currentItem.city || !currentItem.voivodeship) {
      if(!currentItem.name) {
        let nameInput = document.getElementById("name");
        nameInput.classList.add("form-input-invalid");
        nameInput.placeholder = `ten element jest wymagany`;
      }
      if(!currentItem.address) {
        let shortNameInput = document.getElementById("address");
        shortNameInput.classList.add("form-input-invalid");
        shortNameInput.placeholder = `ten element jest wymagany`;
      }
      if(!currentItem.postalCode) {
        let shortNameInput = document.getElementById("postalCode");
        shortNameInput.classList.add("form-input-invalid");
        shortNameInput.placeholder = `ten element jest wymagany`;
      }
      if(!currentItem.city) {
        let shortNameInput = document.getElementById("city");
        shortNameInput.classList.add("form-input-invalid");
        shortNameInput.placeholder = `ten element jest wymagany`;
      }
      if(!currentItem.voivodeship) {
        let shortNameInput = document.getElementById("voivodeship");
        shortNameInput.classList.add("form-input-invalid");
        shortNameInput.placeholder = `ten element jest wymagany`;
      }

      return;
    }

    let response;
    const item = {
      id: currentItem.id,
      name:currentItem.name,
      address: currentItem.address,
      postalCode: currentItem.postalCode,
      city: currentItem.city,
      code: currentItem.code,
      voivodeship: {
        id: currentItem.voivodeship.id
      }
    };

    if (currentFormState.formAddingDataMode) {
      response = await createItem(dataUrl, item, state);
    } else {
      response = await updateItem(`${dataUrl}/${item.id}`, item, state);
    }

    if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true});
    } else if (response.status === 409) {
      setUpdateConflict(true);
    } else {
      response && onSaveAndClose({state});
    }
  }

  const checkRelatedItems = async (id) => {
    //const data = await getRelatedChildrenByParentId(`${ relatedItemsUrl }/${ id }`, id, setEventsList);
    //data.length === 0 ? setAllowDelete(true) : setAllowDelete(false);
    setAllowDelete(true);
  }

  const onClose = () => {
    setUpdateConflict(false);
    onCloseDetails({state});
  };

  useEffect(() => {
    if (updateConflict) setUpdateConflict(false);
    compareData(currentFormState, setCurrentFormState, currentItem, backupItem);
  }, [itemChanged])

  useEffect(() => {
    if (allowDelete !== null) {
      onItemsListDeleteButtonClick(currentFormState, setCurrentFormState, itemName, allowDelete, currentItem.name);
    }
  }, [allowDelete])

  useEffect(() => {
    const getData = async () => {
      const [itemsData, voivodeshipsData] =
        await Promise.all([
          getItems(dataUrl),
          getItems(voivodeshipsUrl)
        ]);

      const success =
        itemsData.status === 200 &&
        voivodeshipsData.status === 200

      if (success) {
        setLoading(false);
        setItems(itemsData.data);
        setVoivodeships(voivodeshipsData.data);
      } else {
        navigate('/login', { state: { from: location }, replace: true})
      }

    };
    getData();
  }, [])


  const getCompleteItem = async (id) => {
    const response = await getItems(`${dataUrl}/${id}`);
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 401 || response.status === 403) {
      navigate('/login', {state: {from: location}, replace: true})
    } else {
      alert("Nie udało się pobrać danych.");
    }
  }


  const addDataButtonProps = {
    setCurrentItem,
    setBackupItem,
    defaultItem,
    currentFormState,
    setCurrentFormState,
    formDescription: `Tu możesz dodać nowy element.`,
    formHeader: `Nowy element`,
    buttonTitle: ` Dodaj nowy Urząd skarbowy`
  }


  let dataSectionContent;
  if (loading) {
    dataSectionContent = <LoadingDataDiv/>
  } else if (itemsList.length > 0) {
    dataSectionContent =
      <Table
        rows={itemsList}
        columns={columns}
        state={state}
        checkRelatedItems={checkRelatedItems}
        formHeader={`Edycja ${itemName}`}
        relatedItemsUrl={relatedItemsUrl}
        getCompleteItem={getCompleteItem}
      />
  } else {
    dataSectionContent =
      <div className={"warn_info"}><FontAwesomeIcon
        className={"warning-icon div-visible"} icon={faExclamationCircle}/>&nbsp;&nbsp;&nbsp;NIE ZNALEZIONO ŻADNYCH DANYCH</div>
  }
  return (
    <div id="layoutSidenav_content" className="settings-entity-page">
      <AppComponentCardHeader title="Urzędy skarbowe" buttonProps={addDataButtonProps}/>

      <div className="container-fluid px-4 py-3">
        <div className={itemsList.length > 0 ? "card shadow p-1 mb-5 bg-white rounded-2" : "card shadow mb-5 bg-transparent rounded-2"}>
          {dataSectionContent}
        </div>
      </div>

      <SettingsEntityModal
        show={currentFormState.showForm}
        onClose={onClose}
        title={currentFormState.formAddingDataMode ? "Nowa pozycja: Urząd skarbowy" : `Edycja: ${currentItem.name || "Urząd skarbowy"}`}
        adding={currentFormState.formAddingDataMode}
        introText="Dane urzędu skarbowego są wykorzystywane w kartotekach i danych wymaganych do rozliczeń."
        onRestore={() => { setUpdateConflict(false); restoreFormData({state}); }}
        onDelete={onDelete}
        onSubmit={onSaveItemClick}
        state={state}
        size="lg"
      >
        <form id="add-taxoffice-form" name="add-taxoffice-form" className="settings-form-content-card">
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <div className="md-form mb-0">
                                        <label htmlFor="name" className="">Nazwa <span className="required">*</span></label>
                                        <TextInput propertyName="name" required={true} state={ state }/>
                                      </div>
                                    </div>
                                    <div className="col-md-12">
                                      <div className="md-form mb-0">
                                        <label htmlFor="address" className="">Adres <span className="required">*</span></label>
                                        <TextInput  propertyName="address" required={true} state={ state }/>
                                      </div>
                                    </div>
                                    <div className="col-md-12">
                                      <div className="md-form mb-0">
                                        <label htmlFor="postalCode" className="">Kod pocztowy <span className="required">*</span></label>
                                        <TextInput  propertyName="postalCode" state={ state }/>
                                      </div>
                                    </div>
                                    <div className="col-md-12">
                                      <div className="md-form mb-0">
                                        <label htmlFor="city" className="">Miasto <span className="required">*</span></label>
                                        <TextInput  propertyName="city" state={ state }/>
                                      </div>
                                    </div>
                                    <div className="col-md-8">
                                      <div className="md-form mb-0">
                                        <label htmlFor="voivodeship" className="">Województwo <span className="required">*</span></label>
                                        <Select
                                          label="Województwo"
                                          propertyName="voivodeship"
                                          required={false}
                                          state={state}
                                          itemsList={voivodeshipsList}
                                          itemName="voivodeship"
                                          displayNames={["name"]}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="md-form mb-0">
                                        <label htmlFor="code" className="">Kod urzędu</label>
                                        <TextInput
                                          propertyName="code"
                                          required={true}
                                          state={state}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <p id="conflict_notification" className={updateConflict ? "err_info" : "offscreen"}>
                                <FontAwesomeIcon icon={faInfoCircle} />&nbsp;
                                Nie można dodać ani zmienić tego elementu, ponieważ istnieje już wpis o tej nazwie i/lub skrócie
                              </p>
                            </form>
      </SettingsEntityModal>

      <DeleteWarningModal state={state} onDelete={onDelete} deleteItemName={itemName}/>
    </div>
  );
}

export default TaxOffice;
